module.exports = __webpack_public_path__ + "static/img/ksy.c0d30b83.png";